import {DefaultPluginConfig, initPlugin, PluginConfig, registerPlugin} from "../lib/plugin";
import {TipMenuConfig} from "./tipmenu";
import {EnabledPlugin} from "../lib/PluginHandler";
import {TextConfig} from "./text";

const cubeIntervals = {}

interface CubeConfig extends DefaultPluginConfig {
    width?: number
    height?: number
    delay?: number
    horizontal?: 'left'|'right'
    horizontalSpace?: number
    vertical?: 'top'|'bottom'
    verticalSpace?: number
    faces: {
        background?: string
        plugin: EnabledPlugin<any>
    }[]
}

const render = (id: string, config: PluginConfig<CubeConfig>) => {
    if (!config.enabled) {
        return
    }

    // @ts-ignore
    let field: HTMLDivElement = document.getElementById('plugin--cube--' + id)
    if (field) {
        field.parentNode.removeChild(field)
    }

    if (typeof cubeIntervals[id] !== 'undefined') {
        clearInterval(cubeIntervals[id])
        delete cubeIntervals[id]
    }

    console.log('render cube', id, config)

    field = document.createElement('div')
    field.id = 'plugin--cube--' + id
    field.style.position = 'absolute'

    if (config.horizontal === 'left') {
        field.style.left = `${config.horizontalSpace}px`
    } else {
        field.style.right = `${config.horizontalSpace}px`
    }

    if (config.vertical === 'top') {
        field.style.top = `${config.verticalSpace}px`
    } else {
        field.style.bottom = `${config.verticalSpace}px`
    }

    const cube = document.createElement('div')
    cube.classList.add('plugin--cube__cube')

    let numOfFaces = 0
    for (const side of config.faces) {
        const face = document.createElement('div')
        face.classList.add('face')
        face.classList.add('face-' + numOfFaces)
        face.style.background = side.background
        cube.appendChild(face)

        initPlugin(side.plugin, face)
        numOfFaces ++
    }

    const singleSideRotation = 360 / numOfFaces

    field.appendChild(cube)

    let translateZ = Math.floor(config.width / 3) * .864

    field.innerHTML += `
<style>
#plugin--cube--${id} {
    width: ${config.width}px;
    height: ${config.height}px;
}
#plugin--cube--${id} .plugin--cube__cube {
    position: relative;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform .5s;
}
#plugin--cube--${id} .plugin--cube__cube .face {
    width: 100%;
    height: 100%;
    position: absolute;
}
#plugin--cube--${id} .plugin--cube__cube .face:not(.current) {
    visibility: hidden;
}
#plugin--cube--${id} .plugin--cube__cube.show-next .face.prev {
    visibility: visible;
}
#plugin--cube--${id} .plugin--cube__cube .face > * {
    width: 100%;
}
${numOfFaces === 3 ? (`
    #plugin--cube--${id} .face-0 {
        transform: rotateY(0deg) translateZ(${translateZ}px);
    }
    #plugin--cube--${id} .face-1 {
        transform:  rotateY(${singleSideRotation}deg) translateZ(${translateZ}px);
    }
    #plugin--cube--${id} .face-2 {
        transform: rotateY(${2 * singleSideRotation}deg) translateZ(${translateZ}px);
    }
`) : ''}
${numOfFaces === 4 ? (`
    #plugin--cube--${id} .face-0 {
        transform: translateZ(${config.width/2}px) rotateY(0deg);
    }
    #plugin--cube--${id} .face-1 {
        transform: translateX(${config.width/2}px) rotateY(${singleSideRotation}deg);
    }
    #plugin--cube--${id} .face-2 {
        transform: translateZ(-${config.width/2}px) rotateY(${2 * singleSideRotation}deg);
    }
    #plugin--cube--${id} .face-3 {
        transform: translateX(-${config.width/2}px) rotateY(${3* singleSideRotation}deg);
    }
`) : ''}
</style>
    `

    document.body.appendChild(field)

    field.querySelector(`.plugin--cube__cube .face-0`).classList.add('current')
    field.querySelector(`.plugin--cube__cube .face-1`).classList.add('next')

    let rotation = 0
    let current = 0
    cubeIntervals[id] = setInterval(() => {
        const cube: HTMLDivElement = field.querySelector('.plugin--cube__cube')

        cube.classList.remove(`show-${cube.getAttribute('data-current')}`)

        rotation += singleSideRotation

        console.log('rotate', rotation + 'deg')

        field.querySelector(`.plugin--cube__cube`).classList.add('show-next')
        cube.style.transform = `rotate3d(0, 1, 0, -${rotation}deg)`
        setTimeout(() => {
            field.querySelector(`.plugin--cube__cube`).classList.remove('show-next')
            field.querySelector(`.plugin--cube__cube .face.prev`).classList.remove('prev')
        }, 800)

        let prev = current

        current ++
        if (current === numOfFaces) {
            current = 0
        }
        let next = current + 1
        if (next === numOfFaces) {
            next = 0
        }

        field.querySelectorAll(`.plugin--cube__cube .face`).forEach(el => el.classList.remove('prev', 'current', 'next'))

        field.querySelector(`.plugin--cube__cube .face-${prev}`).classList.add('prev')
        field.querySelector(`.plugin--cube__cube .face-${current}`).classList.add('current')
        field.querySelector(`.plugin--cube__cube .face-${next}`).classList.add('next')
    }, config.delay * 1000)
}

registerPlugin<CubeConfig>('cube', 'Cube', {
    defaultSettings: [ "horizontal", "vertical", "horizontalSpace", "verticalSpace" ],

    settings: {
        enabled: {
            title: 'enabled',
            type: 'check',
            defaultValue: true,
        },
        width: {
            title: 'Width',
            type: 'number',
            defaultValue: 300,
        },
        height: {
            title: 'Height',
            type: 'number',
            defaultValue: 400,
        },
        delay: {
            title: 'Delay',
            help: 'Delay between switching to next side in seconds',
            type: 'number',
            defaultValue: 5,
        },
        horizontal: {
            title: 'Horizontal',
            type: 'select',
            options: ['left', 'right'],
            defaultValue: 'left',
        },
        horizontalSpace: {
            title: 'Space',
            type: 'number',
            defaultValue: 30,
        },
        vertical: {
            title: 'Vertical',
            type: 'select',
            options: ['top', 'bottom'],
            defaultValue: 'top',
        },
        verticalSpace: {
            title: 'Space',
            type: 'number',
            defaultValue: 30,
        },
    },

    initialize: (id, config: PluginConfig<CubeConfig>) => {
        console.log('cube plugin init', id, config)

        config = {
            width: 300,
            height: 400,
            delay: 3,
            ...config,
        }

        config.faces = [
            {
                plugin: {
                    id: 'foo-tipmenu',
                    plugin: 'tipmenu',
                    config: {
                        enabled: true,
                        "items": "Item 1: | 10\nItem 2: | 20\nItem 3: | 30",
                        "size": 22,
                        "family": "sans-serif",
                        "weight": "normal",
                        "color": "#000000",
                        "tableBorderColor": "#000000",
                        "tableBorderWidth": 0,
                        "tableBorderInnerColor": "#efefef",
                        "tableBorderInnerWidth": 0,
                        "tableBackgroundTransparent": 100,
                        "tableBackground": "#fff",
                        "outerPaddingHorizontal": 20,
                        "outerPaddingVertical": 20,
                        "innerPaddingHorizontal": 13,
                        "innerPaddingVertical": 8,
                        "horizontal": "left",
                        "horizontalSpace": 15,
                        "vertical": "bottom",
                        "verticalSpace": 10
                    }
                } as EnabledPlugin<TipMenuConfig>
            },
            {
                plugin: {
                    id: 'foo-text2',
                    plugin: 'text',
                    config: {
                        enabled: true,
                        name: '2',
                        align: 'center',
                    }
                } as EnabledPlugin<TextConfig>
            },
            {
                plugin: {
                    id: 'foo-text3',
                    plugin: 'text',
                    config: {
                        enabled: true,
                        name: '3'
                    }
                } as EnabledPlugin<TextConfig>
            },
            {
                plugin: {
                    id: 'foo-text4',
                    plugin: 'text',
                    config: {
                        enabled: true,
                        name: '4'
                    }
                } as EnabledPlugin<TextConfig>
            },
        ]

        render(id, config)
    },

    onConfig: (id, config) => {
        console.log('cube plugin config', id, config)
        render(id, config)
    },

    onRemove: (id) => {
        console.log('cube image plugin', id)
        let field = document.getElementById('plugin--cube--' + id)
        if (field) {
            field.parentNode.removeChild(field)
        }
    },

    onWsAction: () => false
})